import React from 'react';
export var reactUIFeatureFlagsDefault = {
  tokenInputRemoveWhitespaceFromDefaultDelimiters: false,
  kebabHintRemovePin: false,
  sidePageEnableFocusLockWhenBackgroundBlocked: false,
  spinnerLoaderRemoveDefaultCaption: false,
  menuItemsAtAnyLevel: false,
  textareaUseSafari17Workaround: false,
  linkFocusOutline: false,
  comboBoxAllowValueChangeInEditingState: false,
  hintAddDynamicPositioning: false,
  popupUnifyPositioning: false
};
export var ReactUIFeatureFlagsContext = /*#__PURE__*/React.createContext(reactUIFeatureFlagsDefault);
ReactUIFeatureFlagsContext.displayName = 'ReactUIFeatureFlagsContext';
ReactUIFeatureFlagsContext.__KONTUR_REACT_UI__ = 'ReactUIFeatureFlagsContext';